var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 8.00001C14.4001 9.69739 13.7258 11.3253 12.5256 12.5255C11.3253 13.7257 9.69748 14.4 8.0001 14.4C6.30271 14.4 4.67485 13.7257 3.47461 12.5255C2.27438 11.3253 1.6001 9.69739 1.6001 8.00001C1.6001 6.30262 2.27438 4.67476 3.47461 3.47452C4.67485 2.27429 6.30271 1.60001 8.0001 1.60001C9.69748 1.60001 11.3253 2.27429 12.5256 3.47452C13.7258 4.67476 14.4001 6.30262 14.4001 8.00001ZM8.8001 11.2C8.8001 11.4122 8.71581 11.6157 8.56578 11.7657C8.41575 11.9157 8.21227 12 8.0001 12C7.78792 12 7.58444 11.9157 7.43441 11.7657C7.28438 11.6157 7.2001 11.4122 7.2001 11.2C7.2001 10.9878 7.28438 10.7844 7.43441 10.6343C7.58444 10.4843 7.78792 10.4 8.0001 10.4C8.21227 10.4 8.41575 10.4843 8.56578 10.6343C8.71581 10.7844 8.8001 10.9878 8.8001 11.2ZM8.0001 4.00001C7.78792 4.00001 7.58444 4.08429 7.43441 4.23432C7.28438 4.38435 7.2001 4.58783 7.2001 4.80001V8.00001C7.2001 8.21218 7.28438 8.41566 7.43441 8.56569C7.58444 8.71572 7.78792 8.80001 8.0001 8.80001C8.21227 8.80001 8.41575 8.71572 8.56578 8.56569C8.71581 8.41566 8.8001 8.21218 8.8001 8.00001V4.80001C8.8001 4.58783 8.71581 4.38435 8.56578 4.23432C8.41575 4.08429 8.21227 4.00001 8.0001 4.00001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/ExclamationCircle.ccd430fcf7ff6e6deb8e00200815c0cc.svg";
export { ForwardRef as ReactComponent };